import { render, staticRenderFns } from "./comment_templates_modal.vue?vue&type=template&id=fe967644&vue3"
import script from "./comment_templates_modal.vue?vue&type=script&lang=js&vue3"
export * from "./comment_templates_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports